<template>
    <div id="sso_topbar" class="sso_bg">
    <div class="sso_pw fix">
        <div id="sso_loginBar">
            <a target="_blank" title="雅昌首页" href="//www.artron.net/" class="sso_home sso_btn">雅昌首页</a>
            <div class="sso_optionInput">
                <!-- 登录后 -->
                <div id="member_after_login"  v-if="isLogin">
                    <span class="sso_wel"><b>{{personName}}</b></span><a target="_self" class="sso_login" href="javascript:void(0)" @click="exit">退出</a>
                </div>
                <!-- 登录前 -->
                <div id="member_before_login" v-else>
                    <span class="sso_wel sso_fl">您好！</span><a href="javascript:;" @click="gotoLogin" class="sso_login sso_fl">请登录</a><a target="_self" href="javascript:void(0)" @click="gotoResiger" class="sso_reg sso_fl">免费注册</a>
                </div>
            </div>
            <div class="sso_select sso_myArtron">
                <div class="sso_site" :class="{'hover':myHover}" @mouseenter="hoverMy(1)" @mouseleave="hoverMy(2)">
                    <div class="sso_dropdown oh">
                        <a class="sso_siteTit icon-artron" href="//passport.artron.net/memCenter/index/" title="我的雅昌" target="_blank">我的雅昌</a><b class="sso_dropBtn"></b>
                    </div>
                    <ul class="sso_siteList" style="overflow: hidden;" :style="{height:myHover?'155px':'0px',paddingBottom:myHover?'10px':'0px'}">
                        <li><a class="icon-buy" href="//passport.artron.net/memCenter/buyer/" target="_blank">求购作品</a></li>
                        <li><a class="icon-release" href="//passport.artron.net/service/product/" target="_blank">发布作品</a></li>
                        <li><a class="icon-attention" href="//passport.artron.net/memCenter/attention/" target="_blank">我的关注</a></li>
                        <li><a class="icon-collect" href="//passport.artron.net/memCenter/collection/index" target="_blank">我的收藏</a></li>
                        <li><a class="icon-SetUp" href="//passport.artron.net/service/product/company" target="_blank">服务中心</a></li>
                    </ul>
                </div>
            </div>
            <a class="sso_buying" href="//passport.artron.net/memCenter/buyer/" target="_blank">求购单<span>（0）</span></a>
            <a class="sso_news" href="//passport.artron.net/memCenter/message/index/" target="_blank">消息<!--<span>（0）</span>--></a>
        </div>
        <div class="sso_other">
            <a href="//help.artron.net/" title="帮助中心" target="_blank">帮助中心</a>
        </div>
        <div class="sso_select sso_artSite">
            <div class="sso_site" :class="{'hover':artronLink}" @mouseenter="hoverLink(1)" @mouseleave="hoverLink(2)">
                <div class="sso_dropdown oh">
                    <a target="_self" class="sso_siteTit" href="###" title="雅昌子站">雅昌子站</a><b class="sso_dropBtn"></b>
                </div>
                <ul class="sso_siteList" :style="{height:artronLink?'155px':'0px',paddingBottom:artronLink?'10px':'0px'}">
                    <li><a href="//huanan.artron.net/" target="_blank">华南站</a></li>
                    <li><a href="//huadong.artron.net/" target="_blank">华东站</a></li>
                    <!--<li><a href="//fj.artron.net/" target="_blank">福建站</a></li>-->
                    <li><a href="//gd.artron.net" target="_blank">广东站</a></li>
                    <!--<li><a href="//jx.artron.net" target="_blank">江西站</a></li>-->
                    <!--<li><a target="_blank" href="//hn.artron.net/">河南站</a></li>-->
                    <li><a href="//ebook.artron.net/" target="_blank">图书网</a></li>
                    <li><a href="//en.artron.net/" target="_blank">英文站</a></li>
                </ul>
            </div>
        </div>
        <div class="sso_topTel">
            <a href="//help.artron.net/service/" target="_blank"><b class="sso_fl">客服热线：</b><span>400 601 8111</span></a>
        </div>
        <div class="sso_select sso_homeSer">
            <div class="sso_site" :class="{'hover':homeHover}" @mouseenter="hoverHome(1)" @mouseleave="hoverHome(2)">
                <div class="sso_dropdown oh">
                    <a class="sso_siteTit" style="color:#666;">主页服务</a><b class="sso_dropBtn"></b>
                </div>
                <ul class="sso_siteList" :style="{height:homeHover?'75px':'0px',paddingBottom:homeHover?'10px':'0px',paddingTop:homeHover?'15px':'0px',borderWidth:homeHover?'1px':'0px',borderStyle:'solid',borderColor:'#b3b3b3'}">
                    <li class="first"><span class="sso_serArist"><a href="//artist.artron.net/" target="_blank">艺术家</a></span><span class="sso_serGal"><a href="//gallery.artron.net/" target="_blank">画廊</a><i>/</i><a href="//crc.artron.net" target="_blank">古玩店</a></span><span class="sso_serAuc"><a href="//auction.artron.net/" target="_blank">拍卖</a></span></li>
                    <li><span class="sso_serArist"><a href="//artist.artron.net/yishujiaintroduce/" target="_blank">特权介绍</a></span><span class="sso_serGal"><a href="//gallery.artron.net/help/introduce/" target="_blank">特权介绍</a></span><span class="sso_serAuc"><a href="//auction.artron.net/help/introduce/html/introduce_brand.html" target="_blank">特权介绍</a></span></li>
                    <li><span class="sso_serArist"><a href="//passport.artron.net/service/artist/" target="_blank">现在开通</a></span><span class="sso_serGal"><a href="//passport.artron.net/service/gallery/" target="_blank">现在开通</a></span></li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "topNav",
    data(){
        return{
            isLogin:false,
            uid:0,
            headerImg:'',
            personName:'',
            myHover:false,
            homeHover:false,
            artronLink:false
        }
    },
    mounted() {
        this.uid = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? this.formatZero(this.getCookie('_at_pt_0_')) : 0;
        this.headerImg  = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0?'https://img12'+ '.artimg.net/passport/avatar/' +this.uid .substring(0, 3) + '/' + this.uid .substring(3, 6) + '/' + this.uid.substring(6, 9) + '/150_150.png?t='+new Date().getTime() : '';
        this.personName = this.getCookie('_at_pt_1_') ? decodeURI(this.getCookie('_at_pt_1_')) : '';
        this.isLogin = this.uid > 0 ? 1 : 0
    },
    methods:{
        hoverMy(num){
            if(num == 1){
                this.myHover = true
            }else{
                this.myHover = false
            }
        },
        hoverHome(num){
            if(num == 1){
                this.homeHover = true
            }else{
                this.homeHover = false
            }
        },
        hoverLink(num){
            if(num == 1){
                this.artronLink = true
            }else{
                this.artronLink = false
            }
        },
        gotoLogin:function (){
            window.location.href = '//passport.artron.net/login?appId=1&redirect='+encodeURIComponent(window.location.href)
        },
        gotoResiger:function (){
            window.location.href = '//passport.artron.net/register?appId=1&redirect='+encodeURIComponent(window.location.href)
        },
        exit:function (){
            window.location.href = '//passport.artron.net/memCenter/logout?redirect='+encodeURIComponent(window.location.href)
        },
        openPerson(){
            this.personShow = !this.personShow;
        },
        getCookie:function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if(document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            }else {
                return null;
            }
        },
        formatZero:function (num) {
            if(num.length < 9){
                num = (Array(10-num.length).join(0) + num);
                return num;
            }else{
                return num;
            }
        },
    }
}
</script>

<style scoped lang="scss">

.fix:after{clear:both;content:" ";display:block;font-size:0;height:0;line-height:0;visibility:hidden;}
.sso_input{border:1px solid #D4D4D4;color:#000;height:22px;line-height:22px;font-size:12px;padding:3px 5px;}
.sso_inputH{height:20px;line-height:20px;border-color:#D4D4D4;border-width:2px;padding:2px 4px;}
.sso_focus{height:20px;line-height:20px;border-width:2px;padding:2px 4px;}
.sso_optionInput{position:relative;display:inline;zoom:1;float:left;}
.sso_optionInput .hover{background:#09C;color:#FEFEFE;}
.sso_bg{background:#e6e6e6;}
.sso_pw{width:980px;margin:0 auto; height:34px;}
#sso_loginBar { line-height:32px; line-height:34px \9;}
#sso_topbar{position:relative;font-size:0;border-top:1px solid #bbbbbb; border-bottom:1px solid #e6e6e6;-moz-box-shadow:0 1px 6px #999;-webkit-box-shadow:0 1px 6px #999;box-shadow:0 1px 6px #999; color:#666; font-family:Microsoft Yahei;}
#sso_topbar a{text-decoration:none; color:#666; font-family:Microsoft Yahei;}
.sso_select{float:right;width:88px;display:inline; position:relative; height:35px;}
#sso_loginBar .sso_select{width:116px;float:left;}
.sso_select .sso_dropdown{display:block;width:117px; height:34px;}
.sso_select .sso_dropdown a{float:left; padding:0 0 0 16px;line-height: 32px;}
.sso_select .sso_dropdown a span { font-size:14px;}
.sso_select .sso_dropdown .icon-artron {vertical-align:middle; margin-right:11px;}
.sso_select .sso_dropBtn{position:absolute;right:5px;top:0px;width:25px; background-image:url(https://pubunder.artron.net/issue_public/issue_top/imgs/sso_arrow.gif); background-repeat:no-repeat;height:34px;cursor:pointer;-webkit-transition:all .2s ease-in;-moz-transition:all .2s ease-in;-o-transition:all .2s ease-in;transition:all .2s ease-in;transform-origin:50% 50%;background-position:center;}
.sso_select .hover .sso_siteTit{color:#FEFEFE;}
.sso_select .hover .sso_dropBtn{visibility:visible;-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg);}
.sso_select .sso_siteList{width:91px;display:none;overflow:hidden;zoom:1; padding-bottom:10px;}
.sso_myArtron .sso_siteList { width:117px;}
.sso_siteList li{zoom:1;vertical-align:middle; line-height:31px;text-align: left;}
.sso_siteList a{display:block;padding-left:16px; background-color:#fafafa; font-family:Microsoft Yahei;}
.sso_siteList a span { font-size:14px; vertical-align:middle; margin-right:11px;}
#sso_topbar .sso_other{float:right;margin-left:10px;}
#sso_topbar .sso_other a{display:inline-block;vertical-align:middle;color:#000;float:left;padding:8px 0 5px 9px; color:#666; line-height:normal;}
#sso_topbar .sso_other a.fred{color:#FFF;background:#000;display:inline;margin-left:9px;padding:0;}
#sso_topbar .sso_other a.fred:hover{background:#09C;}
#sso_loginBar strong{font-size:12px;color:#000;line-height:24px;margin-left:0;}
#sso_loginBar a em{font-style:normal;color:#09C;font-weight:700;font-family:Verdana;font-size:11px;}
#sso_nav_member{z-index:999;width:90px;position:relative;}
#topFix{position:fixed;_position:absolute; z-index:12;top:0px;left:0px;width:100%;}
#sso_topbar .sso_pw{font-size:12px; height:34px;}
.sso_site { position:absolute; left:0; top:0;}
#sso_loginBar a{margin-right:10px;vertical-align:0;color:#666; font-family:Microsoft Yahei;}
#sso_loginBar .sso_password,#sso_loginBar .sso_regesit{color:#666;}
#sso_loginBar{float:left;display:inline;width:528px;padding-right:0;}
#sso_loginBar .sso_btn{color:#FEFEFE;margin:0;}
#sso_loginBar .sso_select .sso_site{border-left:1px solid #d6d6d6;border-right:1px solid #d6d6d6;}
.sso_select .hover{background-color:#fafafa;}
#sso_loginBar .sso_select a{margin:0;}
#sso_loginBar .sso_select .sso_siteTit .icon-artron {color:#0f820c;}
#sso_loginBar .sso_input{height:16px;width:108px;margin-right:10px;line-height:16px;vertical-align:middle;display:inline-block;}
#sso_topbar .sso_topTel{width:170px;float:right;color:#666;padding-top:10px;line-height:1.1;text-align:right;display:inline;font-family:Microsoft Yahei;}
#sso_topbar .sso_topTel a{color:#666;font-family:Microsoft Yahei;font-weight:700;text-decoration:none; display:inline-block; zoom:1; overflow:hidden; width:200px;}
#sso_topbar .sso_topTel a:hover {color:#0f820c;}
#sso_topbar .sso_topTel span{font-family:Verdana, Geneva, sans-serif;float:left;font-weight:700; margin-top:-1px;*margin-top:0px;}
@media screen and (-webkit-min-device-pixel-ratio:0){#sso_topbar .sso_topTel span{ margin-top:0;} }
.sso_cutLine,.cutLine{height:5px;background:#FFF;border-top:1px solid #D4D4D4;overflow:hidden; display:none;}
#sso_topbar .sso_fl{float:left;display:inline;}
#sso_topbar .sso_fr{float:right;display:inline;}
#sso_topbar .sso_topTel .sso_fl{font-family:Microsoft Yahei; font-weight:normal;}
#sso_loginBar span.sso_fl a{line-height:24px;}
#sso_loginBar span.sso_fl .sso_announce{color:#000;margin-right:8px;}
#sso_loginBar .sso_home{float:left;display:inline;background:none;color:#666;margin:0 20px 0 0;}
#sso_loginBar .sso_home:hover{color:#0f820c;}
#sso_loginBar span .sso_exit{color:#999;margin-left:5px;margin-top:1px;line-height:24px;display:inline-block;}
#sso_loginBar .sso_nickName{font-weight:700;font-style:normal;margin:0 5px;}
.sso_optionInput .sso_inBox{position:relative;display:inline-block;float:left;}
.sso_optionInput .sso_inBox .sso_inTxt{top:6px;font-size:12px;color:#ccc;font-family:Simsun;display:block;position:absolute;left:7px;cursor:text;font-style:normal;}
.sso_optionInput .sso_inBox .sso_inTxtOn{color:#e5e5e5;}
#topbar .pw span{font-size:12px;}
.sso_siteList a:hover,#sso_loginBar .sso_select .sso_siteList a:hover{color:#0f820c;}
#sso_topbar .sso_other a:hover,#sso_loginBar .sso_password:hover,#sso_loginBar .sso_regesit:hover,#sso_loginBar a:hover,#sso_loginBar span.sso_fl .sso_announce:hover,#sso_loginBar span .sso_exit:hover{color:#0f820c;}
#sso_loginBar a.sso_btn,#sso_loginBar .sso_siteList a,#sso_loginBar .sso_siteList a:hover,#sso_loginBar .sso_site .hover a{color:#666; font-family:Microsoft Yahei;}
#sso_loginBar .sso_login { color:#0f820c;}
#sso_loginBar .sso_login:hover {text-decoration:underline;}
#sso_loginBar .sso_reg {}

.sso_artSite .sso_site { background:url(https://pubunder.artron.net/issue_public/issue_top/imgs/loginLine.gif) no-repeat right center;}
.sso_artSite .sso_dropdown { width:91px; background:url(https://pubunder.artron.net/issue_public/issue_top/imgs/loginLine.gif) no-repeat left center; line-height:32px; line-height:34px \9;}
.sso_artSite .sso_dropBtn {right:3px;}
.sso_artSite .hover {background:#fafafa; border-left:1px solid #b3b3b3; border-bottom:1px solid #b3b3b3; border-right:1px solid #b3b3b3; width:91px;}
.sso_artSite .hover .sso_dropdown { background:none;}
.sso_artSite .hover a {padding-left:15px;}
#sso_topbar a:hover { color:#0f820c;}
#sso_loginBar .sso_select .hover{background-color:#fafafa; border-left:1px solid #b3b3b3; border-right:1px solid #b3b3b3;border-bottom:1px solid #b3b3b3; width:117px;}
#sso_loginBar .sso_wel{font-family:Microsoft Yahei; margin-right:10px; float:left; display:inline-block; overflow:hidden;}
#sso_loginBar .sso_wel b {color:#0f820c;font-family:Microsoft Yahei;}
#sso_loginBar #member_after_login .sso_wel { max-width:90px;_width:90px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
#sso_loginBar #member_before_login .sso_wel {}

#sso_loginBar .sso_select a { padding-left:39px; font-family:Microsoft Yahei;}
#sso_loginBar .icon-artron { background-image:url(https://pubunder.artron.net/issue_public/issue_top/imgs/sso_home.gif); background-repeat:no-repeat; background-position:15px 9px;}
#sso_loginBar .hover .icon-artron { background-position:15px -76px; font-family:Microsoft Yahei;}
#sso_loginBar .sso_siteList a { background-image:url(https://pubunder.artron.net/issue_public/issue_top/imgs/sso_newMember.gif); background-repeat:no-repeat;}
#sso_loginBar .sso_siteList .icon-member { background-position:15px 9px;}
#sso_loginBar .sso_siteList .icon-attention { background-position:15px -22px;}
#sso_loginBar .sso_siteList .icon-collect { background-position:15px -52px;}
#sso_loginBar .sso_siteList .icon-friends { background-position:15px -83px;}
#sso_loginBar .sso_siteList .icon-SetUp { background-position:15px -115px;}
#sso_loginBar .sso_siteList .icon-buy { background-position:15px -149px;}
#sso_loginBar .sso_siteList .icon-release { background-position:15px -179px;}
#sso_loginBar .sso_siteList .icon-member:hover { background-position:-271px 9px;}
#sso_loginBar .sso_siteList .icon-attention:hover { background-position:-271px -22px;}
#sso_loginBar .sso_siteList .icon-collect:hover { background-position:-271px -52px;}
#sso_loginBar .sso_siteList .icon-friends:hover { background-position:-271px -83px;}
#sso_loginBar .sso_siteList .icon-SetUp:hover { background-position:-271px -115px;}
#sso_loginBar .sso_siteList .icon-buy:hover { background-position:-271px -149px;}
#sso_loginBar .sso_siteList .icon-release:hover { background-position:-271px -179px;}

#sso_loginBar .sso_myArtron { height:35px; width:119px;}
#sso_loginBar .sso_buying { display:inline-block; float:left; height:34px; border-right:1px solid #d5d5d5; padding-right:8px; background:url(https://pubunder.artron.net/issue_public/issue_top/imgs/sso_buyNum.gif) no-repeat left 10px; padding-left:22px; margin-left:15px;}
#sso_loginBar .sso_buying:hover,#sso_loginBar .sso_buyLog { background-position:0 -36px;}
.sso_buying .sso_buyNum { color:#0f820c;}
.sso_buying span { font-family:Verdana;}
.sso_homeSer { width:92px; height:35px; float:right; margin-right:15px;}
.sso_homeSer .sso_dropdown{width:92px; background:url(https://pubunder.artron.net/issue_public/issue_top/imgs/loginLine.gif) no-repeat right center; line-height:32px; height:35px;border:0;}
.sso_homeSer .sso_dropBtn { left:61px;}
.sso_homeSer .hover {background-color:transparent; border:0;}
.sso_homeSer .hover .sso_dropdown {background-image:none;width:92px; background-color:#fafafa; border-left:1px solid #b3b3b3; border-right:1px solid #b3b3b3;}
.sso_homeSer .hover .sso_dropdown a { padding-left:15px;}
.sso_homeSer .sso_siteList { width:296px;border:1px solid #b3b3b3; border-top:0; background-color:#fafafa; padding-bottom:9px; padding-top:15px; background-image:url(https://pubunder.artron.net/issue_public/issue_top/imgs/sso_homeSer.gif); background-repeat:no-repeat; background-position:0 3px;}
.sso_homeSer .sso_siteList a { display:inline; line-height:normal; padding-left:0;}
.sso_homeSer .sso_siteList span { display:block; zoom:1; padding-left:15px; float:left; line-height:normal;}
.sso_homeSer .sso_siteList .sso_serArist { width:78px;}
.sso_homeSer .sso_siteList .sso_serGal { width:95px;}
.sso_homeSer .sso_siteList .sso_serGal i { margin:0 2px; color:#cccccc;}
#sso_topbar .sso_siteList .first .sso_serGal a { margin:0;}
.sso_homeSer .sso_siteList .sso_serAuc { width:77px;}
.sso_homeSer .sso_siteList li { zoom:1; overflow:hidden; line-height:normal; height:25px;*float:left;*width:296px;}
#sso_topbar .sso_siteList .first a { background-color:#000000; color:#FEFEFE; margin-right:5px;}
#sso_topbar .sso_siteList .first a:hover { background-color:#0f820c;}

#sso_loginBar .sso_news { background:url(https://pubunder.artron.net/issue_public/issue_top/imgs/sso_note.gif) no-repeat left -37px; padding-left:22px; display:none; margin-right:0;}
#sso_loginBar .sso_newsAdd { background-position:left -37px;}
.sso_select .sso_siteList{display:block;height:0;padding-bottom:0;transition: .2s height ease-in-out}
.sso_homeSer .sso_siteList{border:0;padding-top: 0;}
</style>